import axios from "../utils/axios";

// ==========================================
// Admin Notification Templates
// ==========================================

export const getNotificationTemplates = async (params) => {
    const response = await axios.get("/admin/notification-templates", { params });
    return response.data;
};

export const getNotificationTemplateById = async (id) => {
    const response = await axios.get(`/admin/notification-templates/${id}`);
    return response.data;
};

export const createNotificationTemplate = async (data) => {
    const response = await axios.post("/admin/notification-templates", data);
    return response.data;
};

export const updateNotificationTemplate = async (id, data) => {
    const response = await axios.put(`/admin/notification-templates/${id}`, data);
    return response.data;
};

export const deleteNotificationTemplate = async (id) => {
    const response = await axios.delete(`/admin/notification-templates/${id}`);
    return response.data;
};

export const previewNotificationTemplate = async (id, data) => {
    const response = await axios.post(`/admin/notification-templates/${id}/preview`, data);
    return response.data;
};

export const testSendNotificationTemplate = async (id, data) => {
    const response = await axios.post(`/admin/notification-templates/${id}/test-send`, data);
    return response.data;
};
